module.exports = __webpack_public_path__ + "img/facebook-logo-white.8ed7e748.svg";